var _rect, _circle, _path, _path2, _path3, _path4, _path5, _circle2, _circle3, _ellipse, _ellipse2, _ellipse3, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayerPortrait10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#f6d34f"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 52,
    fill: "#f7d864",
    opacity: 0.55
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 48C32 22 48 18 60 18S88 22 86 48L87 76C87 82 81 84 76 82H44C39 84 33 82 33 76Z",
    fill: "#2fb5b0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 124C12 98 34 90 60 90S108 98 108 124Z",
    fill: "#f4f1ea"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42 90C44 84 76 84 78 90C76 100 44 100 42 90Z",
    fill: "#c3c0bb"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52 92L50 108M68 92L70 108",
    stroke: "#f3ead6",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52 70H68V92C66 96 54 96 52 92Z",
    fill: "#a26b48"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 56,
    r: 5,
    fill: "#b97a52"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 56,
    r: 5,
    fill: "#b97a52"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60,
    cy: 52,
    rx: 21,
    ry: 25,
    fill: "#b97a52"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45,
    cy: 63,
    rx: 4,
    ry: 2.4,
    fill: "#e8806a",
    opacity: 0.3
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 75,
    cy: 63,
    rx: 4,
    ry: 2.4,
    fill: "#e8806a",
    opacity: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 57Q56.5 62 59 63.5Q60 64 61.5 63.5",
    stroke: "#905f3f",
    strokeWidth: 1.8,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47 55Q51 50 55 55",
    stroke: "#2a1d1a",
    strokeWidth: 2.4,
    fill: "none",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65 55Q69 50 73 55",
    stroke: "#2a1d1a",
    strokeWidth: 2.4,
    fill: "none",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46 47L56 47",
    stroke: "#1f6f6b",
    strokeWidth: 2.2,
    fill: "none",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M64 47L74 47",
    stroke: "#1f6f6b",
    strokeWidth: 2.2,
    fill: "none",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52 67Q60 75 68 67",
    stroke: "#2a1d1a",
    strokeWidth: 2.4,
    fill: "none",
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37 48C34 27 48 21 60 21S86 27 83 48L80 42C70 44 50 44 40 42Z",
    fill: "#2fb5b0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36 56C32 24 50 14 60 14S88 24 84 56",
    stroke: "#2f3a46",
    strokeWidth: 5,
    fill: "none",
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 50,
    width: 9,
    height: 18,
    rx: 4.5,
    fill: "#e8564a"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 50,
    width: 9,
    height: 18,
    rx: 4.5,
    fill: "#e8564a"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 53,
    width: 3,
    height: 12,
    rx: 1.5,
    fill: "#ae4037"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 53,
    width: 3,
    height: 12,
    rx: 1.5,
    fill: "#ae4037"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerPortrait10);
export default __webpack_public_path__ + "static/media/player-portrait-10.625deb84bc45f1e68a9eb7b77b222eb5.svg";
export { ForwardRef as ReactComponent };